import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {FreespinStopPresentation} from "../../presentations/freespin/FreespinStopPresentation";

export class FITH2FSResultPresentation implements FlowStatePresentation {

    public start(flowStateController:FlowStateController):void {
        const presentations:SimplePresentation[] = [];
            presentations.push(new FreespinStopPresentation());
        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback));
    }
}